// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletQuickLinksCard_wql__aYojK {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 3rem 5rem 3rem 5rem;
  border-radius: 1rem;
  background-color: var(--color-fash-primary-4);
  background-size: cover;
  gap: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  height: -moz-fit-content;
  height: fit-content;
}
@media only screen and (max-width: 62.5em) {
  .WalletQuickLinksCard_wql__aYojK {
    padding: 2rem;
  }
}
.WalletQuickLinksCard_wql__links__TI1GI {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  width: 100%;
}
@media only screen and (max-width: 50em) {
  .WalletQuickLinksCard_wql__links__TI1GI {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .WalletQuickLinksCard_wql__links__TI1GI {
    grid-template-columns: repeat(2, 1fr);
  }
}
.WalletQuickLinksCard_wql__links_item__fJ6xp {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3rem;
  gap: 1rem;
  border: 1px solid var(--color-grey);
  border-radius: 1rem;
  box-sizing: border-box;
  width: 100%;
  height: 10rem;
  justify-content: center;
  transition: all 0.4s;
  cursor: pointer;
}
.WalletQuickLinksCard_wql__links_item__fJ6xp:hover {
  border: 2px solid var(--color-fash-primary-3);
  color: var(--color-primary);
  transform: translateX(3px) translateY(3px);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  background-color: var(--color-fash-primary-4);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/WalletQuickLinksCard.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,6CAAA;EACA,sBAAA;EACA,SAAA;EACA,4CAAA;EACA,wBAAA;EAAA,mBAAA;AADF;AAGE;EAbF;IAcI,aAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;AAAJ;AAEI;EANF;IAOI,qCAAA;EACJ;AACF;AACI;EAVF;IAWI,qCAAA;EAEJ;AACF;AAAI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,mCAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;AAEN;AAAM;EACE,6CAAA;EACA,2BAAA;EACA,0CAAA;EACA,4CAAA;EACA,6CAAA;AAER","sourcesContent":["@import \"../variables/breakpoints\";\n\n.wql {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: border-box;\n  padding: 3rem 5rem 3rem 5rem;\n  border-radius: 1rem;\n  background-color: var(--color-fash-primary-4);\n  background-size: cover;\n  gap: 2rem;\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  height: fit-content;\n\n  @media only screen and (max-width: $bp-1000) {\n    padding: 2rem;\n  }\n\n  &__links {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n    width: 100%;\n\n    @media only screen and (max-width: $bp-800) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    &_item {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      font-size: 3rem;\n      gap: 1rem;\n      border: 1px solid var(--color-grey);\n      border-radius: 1rem;\n      box-sizing: border-box;\n      width: 100%;\n      height: 10rem;\n      justify-content: center;\n      transition: all 0.4s;\n      cursor: pointer;\n\n      &:hover {\n        border: 2px solid var(--color-fash-primary-3);\n        color: var(--color-primary);\n        transform: translateX(3px) translateY(3px);\n        box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n        background-color: var(--color-fash-primary-4);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wql": `WalletQuickLinksCard_wql__aYojK`,
	"wql__links": `WalletQuickLinksCard_wql__links__TI1GI`,
	"wql__links_item": `WalletQuickLinksCard_wql__links_item__fJ6xp`
};
export default ___CSS_LOADER_EXPORT___;
